export const getPreviousNextDetailsSectionId = (
  drugDetails,
  activeDetailsSectionIndex,
  activeDetailsSubSectionIndex
) => {
  const toc = drugDetails?.toc;
  if (!toc) {
    return {
      previousDetailsSectionId: undefined,
      nextDetailsSectionId: undefined,
    };
  }
  return {
    previousDetailsSectionId:
      toc[activeDetailsSectionIndex]?.subSection?.[
        activeDetailsSubSectionIndex - 1
      ]?.sectionId ??
      toc[activeDetailsSectionIndex - 1]?.subSection?.slice(-1)?.[0]?.sectionId,
    nextDetailsSectionId:
      toc[activeDetailsSectionIndex]?.subSection?.[
        activeDetailsSubSectionIndex + 1
      ]?.sectionId ??
      toc[activeDetailsSectionIndex + 1]?.subSection?.[0]?.sectionId,
  };
};
